import { Grid } from '@mui/material'
import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DefaultLoader } from '../../../../../components/Loaders'
import { RightSlider } from '../../../../../components/sliders'
import { AppDispatch } from '../../../../../store'
import { GrantActions, GrantSelectors } from '../../../../../store/grant'
import { Grant } from './Grant'
import { GrantCard } from './GrantCard'
import {IAgency} from "../../../../../types";

interface IFormattedGrant{
  _id:string
  phase: string
  agency: IAgency,
  grantId: string
  topicId: string
  dueDate: string
  grantTitle: string
  totalAmount: number,
  formattedAmount: string
  solicitationTitle: string
  solicitationNumber: string
}

interface SmallBusinessAndFederalListProps{
  result: IFormattedGrant[]
}

export const SmallBusinessAndFederalList: FC<SmallBusinessAndFederalListProps> = ({ result }) => {
  const dispatch = useDispatch<AppDispatch>()

  const [showSlider, setShowSlider] = useState(false)

  const grantLoading = useSelector(GrantSelectors.getLoading)

  const fetchGrant = (grantId: string) => {
    const options = {
      params: {
        $includes: 'solicitation,agency',
      },
    }
    dispatch(GrantActions.fetchGrantAsync({ grantId, options }))

    setShowSlider(true)
  }

  const onSliderClose = () => {
    setShowSlider(false)
    dispatch(GrantActions.resetGrant())
  }

  return (
    <>
      <RightSlider open={showSlider} setOpen={setShowSlider} closeButtonAction={onSliderClose}>
        {!grantLoading && <Grant />}
        {grantLoading && <DefaultLoader />}
      </RightSlider>

      <Grid spacing={2} container>
        {result &&
          result.map((grant) => {
            const { agency, dueDate, _id, grantTitle, topicId, formattedAmount } = grant

            return (
              <Grid key={_id} item xs={4} onClick={() => fetchGrant(_id)} sx={{ cursor: 'pointer' }}>
                <GrantCard
                  agency={agency}
                  topicId={topicId}
                  deadline={dueDate}
                  grantTitle={grantTitle}
                  awardAmount={formattedAmount}
                />
              </Grid>
            )
          })}
      </Grid>
    </>
  )
}
